module.exports = __webpack_public_path__ + "img/cod.0b6b8fd2.png";